<p-dialog
  [(visible)]="display"
  [style]="{ width: '40vw' }"
  (onHide)="reloadChangeControlDetail()"
  [modal]="true"
>
  <div *ngIf="errorMessages.length > 0">
    <p-messages severity="error">
      <ng-template pTemplate>
        <span class="p-message-icon pi pi-times-circle"></span>
        <span class="p-ml-2">Please correct the following errors.</span>
        <ul>
          <li *ngFor="let errorText of errorMessages">{{ errorText }}</li>
        </ul>
      </ng-template>
    </p-messages>
  </div>
  <ng-template pTemplate="header">
    <b>Previous Phase Reason</b>
  </ng-template>
  <p>
    {{requiredModalHeader}}
  </p>

  <div class="field field-required">
    <bpt-dropdown
      label="Phase*"
      [options]="chanecontrolPhasesData"
      [(ngModel)]="previousPhase"
      [editable]="false"
      placeholder="Select Phase"
      id="changeControlPreviousPhase"
      [showClear]="true"
      [showFilter]="true"
      [valueField]="valueField"
      [labelField]="labelField"
      [ngClass]="{ 'error-highlight': mandatoryFields.previousPhase }"
    >
    </bpt-dropdown>
  </div>

  <div class="field field-required">
    <bpt-text-input
      [ngClass]="{ 'error-highlight': mandatoryFields.reasonForChange }"
      [highlightAllOnFocus]="true"
      placeholder="Enter the Reason"
      [multiLine]="true"
      id="reasonForPhaseChangeDescription"
      label="Reason*"
      [(ngModel)]="reasonForChange"
    ></bpt-text-input>
  </div>

  <ng-template pTemplate="footer">
    <p-button
      appPreventDoubleClick
      label="Save"
      type="submit"
      id="saveReasonForChangeButton"
      class="align-right"
      (debounceClick)="saveReasonForChange()"
    >
    </p-button>
  </ng-template>
</p-dialog>
